import styled from 'styled-components';

export const InfiniteScroll = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
`;
